var map = {
	"./3dpainting.jpeg": 818,
	"./bondage.jpeg": 615,
	"./dog-painting.jpeg": 175,
	"./people.jpeg": 535,
	"./text.jpeg": 185,
	"./thatscool.jpeg": 421,
	"./trod.jpeg": 450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 498;